import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { PageLoading } from "apps/user/learner/components/page-container";

import {
  AuthLayout,
  EnvelopeIcon,
  Heading,
  PrimaryButton,
} from "apps/user/common/components/auth-layout";

import styles from "./results.module.scss";

interface ResultsProps {
  result: "error " | "success";
}

const Results: React.FC<ResultsProps> = ({ result }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const params = location?.state?.params;
  const canGoBack = location?.state?.canGoBack;
  const title = params?.title;
  const subtitle = params?.subTitle;
  const message = params?.message;
  const buttonAction = params?.buttonAction;
  const buttonText = params?.buttonText;
  const backTo = canGoBack ? "/signup" : null;

  const handleButtonClick = (): void => {
    if (buttonAction === "back" && backTo) {
      navigate(backTo);
    } else if (buttonAction === "sign-in") {
      navigate("/signin");
    } else if (buttonAction === "onboarding") {
      navigate("/user/onboard");
    }
  };

  if (!params) {
    return (
      <div className={styles["page-loading"]}>
        <PageLoading />
      </div>
    );
  }

  return (
    <AuthLayout variant="form">
      <div className={styles["wrapper"]}>
        <div className={styles["icon-disc"]} aria-hidden="true">
          <EnvelopeIcon />
        </div>

        {title && <Heading>{title}</Heading>}
        {subtitle && <p className={styles["subtitle"]}>{subtitle}</p>}
        {message && (
          <p
            className={styles["message"]}
            dangerouslySetInnerHTML={{ __html: message }}
          />
        )}

        {buttonText && (
          <div className={styles["cta"]}>
            <PrimaryButton
              onClick={handleButtonClick}
              variant={result === "success" ? "primary" : "secondary"}
            >
              {buttonText}
            </PrimaryButton>
          </div>
        )}
      </div>
    </AuthLayout>
  );
};

export default Results;
